import { render, staticRenderFns } from "./crearSede.vue?vue&type=template&id=1d35f348"
import script from "./crearSede.vue?vue&type=script&lang=js"
export * from "./crearSede.vue?vue&type=script&lang=js"
import style0 from "./crearSede.vue?vue&type=style&index=0&id=1d35f348&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports